import axios from "axios";
import React, { useEffect, useState } from "react";

const Card = ({ news }) => {
    return (
        <div
            style={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                backgroundColor: "#ccf1be",
                borderRadius: "0 0 10px 10px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
            onClick={() =>
                window.open(
                    news.thumbnailPhoto
                        ? `https://mjutoday.mju.ac.th/news/?newsId=${news.informationID}`
                        : news.webLink,
                    "_blank",
                )
            }
        >
            <div>
                {news.thumbnailPhoto ? (
                    <img
                        src={news.thumbnailPhoto}
                        alt={news.name}
                        style={{
                            height: "180px",
                            objectFit: "cover",
                            width: "100%",
                            borderRadius: "10px 10px 0 0",
                        }}
                    />
                ) : (
                    <img
                        src={`https://arch.mju.ac.th/assets/images/mju_pr.jpg`}
                        alt={news.name}
                        style={{
                            height: "180px",
                            objectFit: "cover",
                            width: "100%",
                            borderRadius: "10px 10px 0 0",
                        }}
                    />
                )}
            </div>
            <div
                style={{
                    // maxWidth: "300px",
                    height: "auto",
                    padding: "10px",
                    color: "#333",
                    fontWeight: "normal",
                    textAlign: "center",
                }}
            >
                {news.name}
            </div>
        </div>
    );
};

export default function MjuPrNews() {
    const [mjuNews, setMjuNews] = useState([]);
    // const baseUrl = "https://apis.mju.ac.th/activity/all/events";
    const baseUrl = "https://apis.mju.ac.th/activity/v1/type7";
    // const baseUrl =
    //     "https://erp.mju.ac.th/informationAPI.aspx?typeID=7&limit=6";

    useEffect(() => {
        // document.title = "MJU PR News";
        axios
            .get(baseUrl, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((response) => {
                console.log("MJU news:", response.data);
                setMjuNews(response.data);
            })
            .catch((error) => {
                console.error("Error fetching MJU PR News:", error);
            });
    }, []);

    return (
        <div style={{ padding: "1rem", marginTop: "40px" }}>
            <h2 style={{ textAlign: "center" }}>...MJU News...</h2>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns:
                        "repeat(auto-fill, minmax(300px, 1fr))",
                    gap: "1rem",
                }}
            >
                {mjuNews.map((newsItem) => (
                    // <li key={newsItem.informationID}>{newsItem.name}</li>
                    <Card key={newsItem.informationID} news={newsItem} />
                ))}
            </div>
        </div>
    );
}